import type { PreviewEnvironmentLogTails } from '../../manager/types.js';
import type { WirePreviewEnvironmentChildDeps } from './deps.js';
import { isStalePreviewEnvironmentChild } from './is-stale-child.js';

export function attachChildErrorHandler(d: WirePreviewEnvironmentChildDeps): void {
  const { proc, title } = d;

  proc.on('error', (err) => {
    const errno =
      typeof err === 'object' && err && 'code' in err ? String((err as NodeJS.ErrnoException).code) : '';
    if (errno === 'ABORT_ERR' && isStalePreviewEnvironmentChild(d)) {
      return;
    }
    const stale = isStalePreviewEnvironmentChild(d);
    const poll = d.getPollInterval();
    if (poll && !stale) {
      clearInterval(poll);
      d.setPollInterval(undefined);
    }
    const cleanupDir = d.mergedCleanupDir;
    if (cleanupDir) {
      d.rmMergedCleanupDir(cleanupDir);
    }
    if (stale) return;
    d.detachProcessFromManager();
    const tails: PreviewEnvironmentLogTails = { stdout: d.stdoutTail.getTail(), stderr: d.stderrTail.getTail() };
    d.clearTailBuffers();
    const msg = err instanceof Error ? err.message : String(err);
    d.log(`[preview-environment] ${title} process error: ${msg}${errno ? ` (${errno})` : ''}`);
    d.sendStatus('error', msg, tails);
  });
}
